import React, { useEffect, useState } from "react";
import DataTables from "../../CommonDataTable/DataTable";
import config from "../../../../config/config";
import apiCalls from "../../../../config/apiCalls";
import ViewModal from "../../CommonModals/viewModal";
import NewUserModal from "../../CommonModals/NewUserModal";
import showToasterMessage from "../../../UI/ToasterMessage/toasterMessage";
import FormModal from "../../../Form/FormModal";
import store from "../../../App/store";
import filePath from "../../../../config/configSampleFiles";
import fetchMethodRequest from "../../../../config/service";
import RolePermissions from "../../CommonModals/Permissions";
import { useParams } from "react-router";
// config file

const ContentGeneration = (props) => {
  const [languageData, setLanguageData] = useState();
  const [rolePermission, setRolePermission] = useState();
  const [rolesList, setRolesList] = useState([]);
  const [gotRoles, setgotRoles] = useState(false);
  const [editSelectedRecord, setEditSelectedRecord] = useState(
    window.location.href.includes("edit")
  );
  const [addSelectedRecord, setAddSelectedRecord] = useState(
    window.location.href.includes("create")
  );
  const [viewSelectedRecord, setViewSelectedRecord] = useState(
    window.location.href.includes("view")
  );
  const [isOpenFormModal, setIsOpenFormModal] = useState(false);
  const [openNewUserModal, setopenNewUserModal] = useState(false);
  const [item, setItem] = useState({});
  const [newFormFields, setNewFormField] = useState([]);

  const params = useParams();
  useEffect(() => {
    getRoleListFromServer();
    let screenPermissions = RolePermissions.screenPermissions("Generate Content");
    if (screenPermissions) {
      setRolePermission(screenPermissions);
    }
  }, []);

  const getDerivedStateFromProps = (props, state) => {
    let storeData = store.getState();
    let languageData =
      storeData &&
        storeData.settingsData &&
        storeData.settingsData.settings &&
        storeData.settingsData.settings.languageTranslation
        ? storeData.settingsData.settings.languageTranslation
        : "";
    return { languageData: languageData };
  };
  const setData = (props) => {
    let rowData = {};
    if (params.id) {
      rowData["_id"] = JSON.parse(params.id);
      return rowData;
    }
  };
  const getRoleListFromServer = async () => {
    let filterCriteria = {},
      url;
    filterCriteria.direction = "asc";
    url = `roles?filter=${JSON.stringify(filterCriteria)}`;
    fetchMethodRequest("GET", url)
      .then(async (res) => {
        if (res && res.roles && res.roles.length > 0) {
          let rolesList = [];
          for (let obj of res.roles) {
            if (obj.role) rolesList.push({ value: obj.role, label: obj.role });
          }
          setRolesList(rolesList);
          setgotRoles(true);
        }
      })
      .catch((err) => {
        setgotRoles(true);
        return err;
      });
  };
  const getTableFields = () => {
    let roleTypes = [
      {
        label: "All",
        value: null,
      },
      {
        label: "Admin",
        value: "Admin",
      },
      {
        label: "Super Admin",
        value: "Super Admin",
      },
      {
        label: "User",
        value: "User",
      },
    ];
    let StatusTypes = [
      {
        label: "All",
        value: null,
      },
      {
        label: "Active",
        value: "Active",
      },
      {
        label: "Inactive",
        value: "Inactive",
      },
      {
        label: "Pending",
        value: "Pending",
      },
    ];
    let data = [
      {
        textAlign: "center",
        width: "5%",
        field: "Check Box",
        label: "Check Box",
        fieldType: "multiple",
        header: "",
        selectionMode: "multiple",
        show: true,
        mobile: true,
        displayInSettings: true,
        displayinlist: "false",
        displayinaddForm: "false",
        displayineditForm: "false",
        globalSearchField: "false",
        isFieldRequired: "false",
        tDisplay: true,
      },
      {
        textAlign: "center",
        width: "5%",
        field: "Sno",
        label: "SNo",
        header: "SNo",
        filter: false,
        sortable: false,
        placeholder: "Search",
        displayinlist: "false",
        displayinaddForm: "false",
        displayineditForm: "false",
        globalSearchField: "false",
        isFieldRequired: "false",
        show: true,
        mobile: true,
        displayInSettings: true,
        tDisplay: true,
      },
      {
        name: "topic",
        type: "text",
        placeholder: "Topic",
        label: "Topic",
        width: "25%",
        addFormOrder: 1,
        editFormOrder: 1,
        header: "Topic",
        derivedValue: "topic=undefined",
        sortable: true,
        filter: true,
        id: "topic",
        displayinaddForm: "true",
        displayineditForm: "true",
        displayinregisterForm: "true",
        displayinlist: "true",
        required: false,
        globalSearchField: "true",
        controllerId: null,
        textAlign: "left",
        show: true,
        field: "topic",
        showOrHideFields: [],
        isFieldRequired: "false",
        mobile: true,
        displayInSettings: true,
        fieldType: "Link",
        style: {
          color: "#0e4768",
          cursor: "pointer",
          textTransform: "capitalize",
        },
        tDisplay: true,
      },

      // {
      //   name: "imagePath",
      //   type: "text",
      //   placeholder: "Image Path",
      //   label: "Image Path",
      //   width: "75%",
      //   addFormOrder: 1,
      //   editFormOrder: 1,
      //   header: "Image Path",
      //   derivedValue: "imagePath=undefined",
      //   sortable: true,
      //   filter: true,
      //   id: "imagePath",
      //   displayinaddForm: "true",
      //   displayineditForm: "true",
      //   displayinregisterForm: "true",
      //   displayinlist: "true",
      //   required: false,
      //   globalSearchField: "true",
      //   controllerId: null,
      //   textAlign: "left",
      //   show: false,
      //   field: "imagePath",
      //   showOrHideFields: [],
      //   isFieldRequired: "false",
      //   mobile: true,
      //   displayInSettings: true,
      //   fieldType: "Link",
      //   style: {
      //     color: "#0e4768",
      //     cursor: "pointer",
      //     textTransform: "capitalize",
      //   },
      //   tDisplay: false,
      // },
      {
        name: "content",
        type: "text",
        placeholder: "Content",
        label: "Content",
        width: "500px",
        // width: "75%",
        addFormOrder: 1,
        editFormOrder: 1,
        header: "Content",
        derivedValue: "content=undefined",
        sortable: true,
        filter: true,
        id: "content",
        displayinaddForm: "true",
        displayineditForm: "true",
        displayinregisterForm: "true",
        displayinlist: "true",
        required: false,
        globalSearchField: "true",
        controllerId: null,
        textAlign: "left",
        show: true,
        field: "content",
        showOrHideFields: [],
        isFieldRequired: "false",
        mobile: true,
        displayInSettings: true,
        // fieldType: "Link",
        style: { width: '90%', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' },
        tDisplay: false,
      },
      {
        name: "type",
        type: "dropDown",
        placeholder: "Type",
        label: "Type",
        header: "Type",
        derivedValue: "type=undefined",
        actions: [],
        width: "5%",
        actionsNumber: [],
        id: "type",
        displayinaddForm: "true",
        displayineditForm: "true",
        displayinlist: "true",
        controllerName: null,
        options: [
          { label: "LinkedIn Post", value: "post", color: "primary" },
          { label: "Blog", value: "blog", color: "success" },
          // { label: "Both", value: "both", color: "danger" }
        ],
        textAlign: "Center",
        show: true,
        disabled: false,
        field: "type",
        mobile: true,
        globalSearchField: "true",
        isFieldRequired: "true",
        required: true,
        displayInSettings: true,
        fieldType: "dropDown",
        addFormOrder: 4,
        editFormOrder: 4,
        defField: true,
        tDisplay: true,
        sortable: true,
        filter: false,
        style: {
          "text-transform": "uppercase"
        }
      },
      // {
      //   name: "created",
      //   type: "date",
      //   placeholder: "Created",
      //   label: "Created",
      //   width: "10%",
      //   header: "Created",
      //   derivedValue: "created=undefined",
      //   actions: [],
      //   actionsNumber: [],
      //   id: "created",
      //   displayinaddForm: "true",
      //   displayineditForm: "true",
      //   displayinlist: "true",
      //   globalSearchField: "true",
      //   controllerId: null,
      //   fieldType: "Date",
      //   dateFormat: config.dateFormat,
      //   textAlign: "Center",
      //   disabled: false,
      //   show: true,
      //   field: "created",
      //   addFormOrder: 10,
      //   editFormOrder: 10,
      //   defField: true,
      //   isFieldRequired: "false",
      //   mobile: true,
      //   displayInSettings: true,
      //   tDisplay: true,
      //   sortable: true,
      //   filter: true,
      // },
      // {
      //   name: "updated",
      //   type: "date",
      //   placeholder: "Updated",
      //   label: "Updated",
      //   width: "110px",
      //   header: "Updated",
      //   derivedValue: "updated=undefined",
      //   actions: [],
      //   actionsNumber: [],
      //   id: "updated",
      //   displayinaddForm: "true",
      //   displayineditForm: "true",
      //   displayinlist: "true",
      //   globalSearchField: "true",
      //   controllerId: null,
      //   fieldType: "Date",
      //   dateFormat: config.dateFormat,
      //   textAlign: "Center",
      //   disabled: false,
      //   show: true,
      //   field: "updated",
      //   addFormOrder: 11,
      //   editFormOrder: 11,
      //   defField: true,
      //   isFieldRequired: "false",
      //   mobile: true,
      //   displayInSettings: true,
      //   tDisplay: true,
      // },
      {
        show: true,
        textAlign: "center",
        width: "5%",
        fieldType: "Actions",
        field: "Actions",
        header: "Actions",
        label: "Actions",
        filter: false,
        sortable: false,
        displayInSettings: true,
        displayinServer: "false",
        displayinlist: "true",
        displayinaddForm: "true",
        displayineditForm: "true",
        globalSearchField: "false",
        isFieldRequired: "false",
        mobile: true,
        tDisplay: true,
      },
    ];

    return data;
  };

  const getFormFields = () => {
    let statusTypes = [
      {
        label: "Active",
        value: "Active",
      },
      {
        label: "Inactive",
        value: "Inactive",
      },
      {
        label: "Pending",
        value: "Pending",
      },
    ];
    return [
      {
        name: "topic",
        type: "text",
        placeholder: "topic",
        label: "topic",
        width: "110",
        addFormOrder: 1,
        editFormOrder: 1,
        derivedValue: "topic=undefined",
        sortable: false,
        filter: true,
        id: "topic",
        displayinaddForm: "true",
        displayineditForm: "true",
        displayinregisterForm: "true",
        displayinlist: "true",
        required: false,
        globalSearchField: "true",
        controllerId: null,
        show: true,
        showOrHideFields: [],
        isFieldRequired: "false",
        mobile: true,
        displayInSettings: true,
        fieldType: "Link",
        style: {
          color: "#0e4768",
          cursor: "pointer",
          textTransform: "capitalize",
        },
        isAddFormHidden: false,
        isEditFormHidden: false,
        required: true,
      },
      {
        name: "type",
        type: "dropDown",
        placeholder: "Type",
        label: "Type",
        header: "Type",
        derivedValue: "type=undefined",
        actions: [],
        width: 50,
        actionsNumber: [],
        id: "type",
        displayinaddForm: "true",
        displayineditForm: "true",
        displayinlist: "true",
        controllerName: null,
        options: [
          { label: "LinkedIn Post", value: "post", color: "warning" },
          { label: "Blog", value: "blog", color: "success" },
          // { label: "Both", value: "both", color: "primary" }
        ],
        textAlign: "Center",
        show: true,
        disabled: false,
        field: "type",
        mobile: true,
        globalSearchField: "true",
        isFieldRequired: "true",
        required: true,
        displayInSettings: true,
        fieldType: "dropDown",
        addFormOrder: 4,
        editFormOrder: 4,
        defField: true,
        tDisplay: true,
      },
    ];
  };

  const submit = async (item) => {
    setIsOpenFormModal(true);
    // await this.formModalRef.getRowData(item, 'edit');
    console.log("Submit Button in sode          ");
  };

  const closeFormModal = async () => {
    setIsOpenFormModal(false);
  };
  const cancelReset = async (type) => {
    setopenNewUserModal(false);
    window.location.reload();
  };
  const getChangedRoleOptions = () => {
    let fields = getFormFields();
    if (fields && fields.length > 0) {
      for (let obj of fields) {
        if (obj.name == "role") {
          obj.options = rolesList && rolesList.length > 0 ? rolesList : [];
        }
      }
    }
    return fields;
  };
  const saveDataToServer = async (item, field, value) => {
    let userBody;
    if (item?.length > 0 && field && value) {
      let selectedIds = item.map((row) => row._id);
      userBody = {
        selectedIds: selectedIds,
        updatedDetails: { [field]: value },
      };
    } else {
      return;
    }
    if (userBody) {
      let method, apiUrl;
      method = "POST";
      apiUrl = `${apiCalls.employees}/multiUpdate`;
      return fetchMethodRequest(method, apiUrl, userBody)
        .then(async (response) => {
          if (response && response.respCode) {
            showToasterMessage(response.respMessage, "success");
          } else if (response && response.errorMessage) {
            showToasterMessage(response.errorMessage, "error");
          }
        })
        .catch((err) => {
          return err;
        });
    } else {
      return;
    }
  };

  return (
    <span>
      {gotRoles && (
        <DataTables
          {...props}
          getTableFields={getTableFields}
          formFields={getChangedRoleOptions}
          //
          addRequired={
            rolePermission && rolePermission == "Edit" ? true : false
          }
          editRequired={
            rolePermission && rolePermission == "Edit" ? true : false
          }
          deleteRequired={
            rolePermission && rolePermission == "Edit" ? true : false
          }
          viewRequired={
            rolePermission && rolePermission == "Edit" ? true : false
          }
          exportRequired={
            rolePermission && rolePermission == "Edit" ? false : false
          }
          sample={false}
          actionsTypes={[
            {
              name: "Delete",
              options: [
                {
                  label: "Delete",
                  value: "Delete",
                  show:
                    rolePermission && rolePermission == "Edit" ? true : false,
                  multiple: true,
                },
              ],
            },
          ]}
          settingsRequired={true}
          filterRequired={false}
          gridRequried={false}
          exportToCsv={true}
          dateSearchRequired={undefined}
          searchInDateRangeField={"undefined"}
          sampleFilePath={filePath.topics}
          setData={setData}
          editSelectedRecord={editSelectedRecord}
          addSelectedRecord={addSelectedRecord}
          viewSelectedRecord={viewSelectedRecord}
          globalSearch={
            "Topics / Content"
          }
          displayName="Topics"
          type="topic"
          routeTo={apiCalls.topics}
          sideFormLeftOrRight=""
          displayViewOfForm="modal"
          apiResponseKey={apiCalls.topics?.toLowerCase()}
          apiUrl={apiCalls.topics}
          selectedId={params.id}
          buttonToolTips={{ add: 'Add User' }}
          softUpdate={true}
          actionOverlayPanel={false}
        />
      )}
      {isOpenFormModal ? (
        <FormModal
          formType="edit"
          openFormModal={isOpenFormModal}
          formFields={formFields}
        />
      ) : null}
      {openNewUserModal ? (
        <NewUserModal
          openNewUserModal={openNewUserModal}
          cancelReset={cancelReset}
          item={item}
          newFormFields={newFormFields}
          recordId={item._id}
          entityType="employees"
          apiUrl={apiCalls.employees}
        />
      ) : null}
    </span>
  );
};

export default ContentGeneration;
